export const cilReload = ["24 24","<path d='M12.451 9.674h8.924v-8.924h-1.5v6.276l-1.225-1.225c-3.728-3.728-9.795-3.728-13.523 0s-3.728 9.795 0 13.523c1.732 1.728 4.122 2.796 6.762 2.796s5.030-1.068 6.762-2.796l-0 0-1.061-1.061c-3.144 3.144-8.259 3.144-11.402 0s-3.144-8.259-0-11.402 8.259-3.144 11.402 0l1.313 1.313h-6.452z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-reload.js
// module id = null
// module chunks = 